import { render, staticRenderFns } from "./SupplierWallet.vue?vue&type=template&id=07d8c8ea&scoped=true&"
import script from "./SupplierWallet.vue?vue&type=script&lang=js&"
export * from "./SupplierWallet.vue?vue&type=script&lang=js&"
import style0 from "./SupplierWallet.vue?vue&type=style&index=0&id=07d8c8ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d8c8ea",
  null
  
)

export default component.exports